import { reactive, readonly } from "vue";
import { ASSISTENT_API_URL } from "@/config/backend"
import axios from "axios";
import authModule from "../auth";
import devicesModule from "../devices";
import useAlert from "@/hooks/useAlert";

const { showAlertByKey } = useAlert();

const state = reactive({
    dateStart: null,
    dateEnd: null,
    callOverview: null,
    processing: false
});

const actions = {
    readReportingData: (newDateStart, newDateEnd) => {
        if (newDateStart !== state.dateStart && newDateEnd !== state.dateEnd && devicesModule.getters.isDeviceSelected()) {
            const url = ASSISTENT_API_URL + "device/" + devicesModule.state.currentDeviceSerialId + "/usage/" + newDateStart + "/" + newDateEnd;

            state.processing = true;
            return axios
                .get(
                    url,
                    {
                        headers: authModule.getters.getApiHeaders()
                    }
                )
                .then((response) => {
                    if (response.data.errorCode !== null) {
                        showAlertByKey(response.data.errorCode);
                    } else {
                        state.callOverview = response.data.resultObject;
                    }
                    state.processing = false;

                })
                .catch(() => {
                    state.processing = false;
                    const errorMessage = new Error('UNKNOWN_ERROR');
                    throw errorMessage;
                });
        }
    },
    reset: async () => {
        state.processing = false;
        state.dateStart = null;
        state.dateEnd = null;
        state.callOverview = null;
    }
}

const reportingModule = {
    state: readonly(state),
    actions
}

export default reportingModule;